module.exports = __webpack_public_path__ + "static/media/dark_arcade_vic_sidious.64ec4b9a.m4a";